import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-server-options',
  template: ''
})
export class ThomasTableServerOptionsComponent {

  requests = {
    Experience: [
      'searchText',
      'TenantKey',
      'CompanyKey',
      'SurveyKey',
      'pageNumber',
      'pageSize',
      'FilterByMetrics'],
    Thomas: [
      'TenantKey',
      'CompanyKey',
      'UserKeys',
      'searchText',
      'pageNumber',
      'pageSize',
      'FilterByMetrics'
    ]
  };
  APIFetch = {
    Experience: 'dynamicTableQuery',
    Thomas: 'dynamicTableQuery'
  };
}
